export const GET_LIVE_ORDERS = "GET_LIVE_ORDERS";
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";
export const GET_SINGLE_ORDER = "GET_SINGLE_ORDER";
export const GET_RETURNED_SINGLE_ORDER = "GET_RETURNED_SINGLE_ORDER";

export const GET_ORDER_DELIVERY_PARTNERS = "GET_ORDER_DELIVERY_PARTNERS";
export const GET_ORDER_RETURNS = "GET_ORDER_RETURNS";
